import React from 'react'
import MyGallery from '../../Components/myGallery'

export const WeddingGallery = () => {
    return (
        <div className='flex flex-col items-center' id='gallery'>
            <div className='container my-10'>


                <MyGallery />

            </div>
        </div>

    )
}
